import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-carousel-minimal';


export default function CarouselImages() {

    const data = [
        {
          image: "https://image-gallery-technomaits.vercel.app/static/media/banner1.a23dbc507a38fa955aae.png",
          
        },
        {
          image: "https://image-gallery-technomaits.vercel.app/static/media/banner2.5a945714ca410294be6c.jpeg",
         
        },
        {
          image: "https://image-gallery-technomaits.vercel.app/static/media/banner3.d6851344f8ac102bdd7c.jpeg",
         
        },
        {
          image: "https://image-gallery-technomaits.vercel.app/static/media/banner4.50ea6b6d4f4399a7964b.png",
        }
        // {
        //   image: "https://i.natgeofe.com/n/f7732389-a045-402c-bf39-cb4eda39e786/scotland_travel_4x3.jpg",
        //   caption: "Scotland"
        // },
        // {
        //   image: "https://www.tusktravel.com/blog/wp-content/uploads/2020/07/Best-Time-to-Visit-Darjeeling-for-Honeymoon.jpg",
        //   caption: "Darjeeling"
        // },
        // {
        //   image: "https://www.omm.com/~/media/images/site/locations/san_francisco_780x520px.ashx",
        //   caption: "San Francisco"
        // },
        // {
        //   image: "https://images.ctfassets.net/bth3mlrehms2/6Ypj2Qd3m3jQk6ygmpsNAM/61d2f8cb9f939beed918971b9bc59bcd/Scotland.jpg?w=750&h=422&fl=progressive&q=50&fm=jpg",
        //   caption: "Scotland"
        // },
        // {
        //   image: "https://www.oyorooms.com/travel-guide/wp-content/uploads/2019/02/summer-7.jpg",
        //   caption: "Darjeeling"
        // }
      ];
    
      const captionStyle = {
        fontSize: '2em',
        fontWeight: 'bold',
      }
      const slideNumberStyle = {
        fontSize: '20px',
        fontWeight: 'bold',
      }



  return (
    <Carousel
    data={data}
    time={4000}
    width="850px"
    height="500px"
    captionStyle={captionStyle}
    radius="10px"
    slideNumber={true}
    slideNumberStyle={slideNumberStyle}
    captionPosition="bottom"
    automatic={true}
    dots={true}
    pauseIconColor="white"
    pauseIconSize="40px"
    slideBackgroundColor="darkgrey"
    slideImageFit="cover"
    thumbnails={true}
    thumbnailWidth="100px"
    style={{
      textAlign: "center",
      maxWidth: "850px",
      maxHeight: "500px",
      margin: "40px auto",
    }}
  />
  )
}
